"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenteredPageContainer = exports.PageHero = exports.TopNavigationBar = exports.PageHeroContainer = exports.PageContent = exports.PageBody = exports.Page = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background: #eee;\n  ", ";\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n  z-index: 2;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background: #dfdfdd url(", ");\n  background-size: cover;\n  background-position: center center;\n  filter: blur(5px);\n  width: 100%;\n  height: 150%;\n  position: absolute;\n  z-index: 1;\n  top: -10%;\n  left: 0;\n  right: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 70px;\n  z-index: 5;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 280px;\n  background-size: cover;\n  background-position: center center;\n  margin-bottom: 50px;\n  position: relative;\n  overflow: hidden;\n  z-index: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding-left: ", ";\n  padding-top: 2px;\n  text-align: left;\n  margin-left: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  max-width: ", ";\n  margin: auto;\n  position: relative;\n  z-index: 1;\n  margin: auto;\n  font-size: ", ";\n  height: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Page = _styledComponents["default"].div(_templateObject());

exports.Page = Page;

var PageBody = _styledComponents["default"].div(_templateObject2(), function (_ref) {
  var padding = _ref.padding;
  return padding || '36px';
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth || '1600px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.normal;
});

exports.PageBody = PageBody;

var PageContent = _styledComponents["default"].div(_templateObject3(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.padding.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizes.filterColWidth;
});

exports.PageContent = PageContent;

var PageHeroContainer = _styledComponents["default"].div(_templateObject4());

exports.PageHeroContainer = PageHeroContainer;

var TopNavigationBar = _styledComponents["default"].div(_templateObject5());

exports.TopNavigationBar = TopNavigationBar;

var PageImage = _styledComponents["default"].div(_templateObject6(), function (_ref6) {
  var url = _ref6.url;
  return url;
});

var Overlay = _styledComponents["default"].div(_templateObject7());

var PageHero = function PageHero(_ref7) {
  var url = _ref7.url;
  return _react["default"].createElement(PageHeroContainer, null, _react["default"].createElement(PageImage, {
    url: url
  }), _react["default"].createElement(Overlay, null));
};

exports.PageHero = PageHero;

var CenteredPageContainer = _styledComponents["default"].div(_templateObject8(), (0, _knotchWebReactComponents.absFull)(0, 0, 0, 0), _knotchWebReactComponents.contentCentered);

exports.CenteredPageContainer = CenteredPageContainer;

//# sourceMappingURL=Page.js.map